<template>
  <div class="page_body">
    <HomeTop :topTitle="topTitle"></HomeTop>
    <div class="analysis-report">
      <!-- 基本信息 -->
      <div class="report-header">
        <div class="basic-info">
          <div class="student-info">
            <span class="name">{{ studentInfo.name }}</span>
            <span class="level">{{ examData.level }}</span>
          </div>
          <div class="test-time">
            测试日期：{{ studentInfo.testTime }}
          </div>
        </div>
      </div>



      <!-- 时间距离数据 -->
      <!-- <div class="time-distance-data">
        <div class="data-box">
          <div class="label">时长</div>
          <div class="value">{{ testDuration }}</div>
        </div>
        <div class="data-box">
          <div class="label">距离(米)</div>
          <div class="value red">{{ testDistance }}</div>
        </div>
        <div class="data-box">
          <div class="label">距离/分钟(米)</div>
          <div class="value">{{ distancePerMinute }}</div>
        </div>
      </div> -->

      <!-- 运动指标数据 -->
      <div class="metrics-grid">
        <!-- 速度指标 -->
        <div class="metric-item">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/speed_icon.png" alt="速度" class="speed-icon">
            </div>
            <div class="metric-title">速度（最大值）km/h</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="30">
              <div class="value-point" :style="{ left: getValuePosition(speed, 30) + '%' }">
                {{ speed }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.speed }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">23.65</span>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 加速负荷 -->
        <div class="metric-item">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/max_acceleration_icon.png" alt="加速负荷" class="max-acceleration-icon">
            </div>
            <div class="metric-title">加速负荷（最大值）</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="10">
              <div class="value-point" :style="{ left: getValuePosition(accelerationLoad, 10) + '%' }">
                {{ accelerationLoad }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.accelerationLoad }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">23.65</span>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 方向改变 -->
        <div class="metric-item">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/direction_icon.png" alt="方向改变" class="direction-icon">
            </div>
            <div class="metric-title">方向的改变（次）</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="100">
              <div class="value-point" :style="{ left: getValuePosition(directionChanges, 100) + '%' }">
                {{ directionChanges }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.directionChanges }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">23.65</span>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 力学强度 -->
        <div class="metric-item">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/mechanical_intensity_icon.png" alt="力学强度" class="mechanical-intensity-icon">
            </div>
            <div class="metric-title">力学强度</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="30">
              <div class="value-point" :style="{ left: getValuePosition(mechanicalIntensity, 30) + '%' }">
                {{ mechanicalIntensity }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.mechanicalIntensity }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">23.65</span>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 跳跃次数 -->
        <div class="metric-item">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/jump_icon.png" alt="跳跃" class="jump-icon">
            </div>
            <div class="metric-title">跳跃（次）</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="50">
              <div class="value-point" :style="{ left: getValuePosition(jumps, 50) + '%' }">
                {{ jumps }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.jumps }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">24</span>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 累积加速负荷 -->
        <div class="metric-item wide">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/acceleration_load_icon.png" alt="累积加速负荷" class="acceleration-load-icon">
            </div>
            <div class="metric-title">累积加速负荷</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="500">
              <div class="value-point" :style="{ left: getValuePosition(accumulatedLoad, 500) + '%' }">
                {{ accumulatedLoad }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.accumulatedLoad }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">245.31</span>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 运动量 -->
        <div class="metric-item">
          <div class="metric-header">
            <div class="metric-icon">
              <img src="@/assets/image/exercise_volume_icon.png" alt="运动量" class="exercise-volume-icon">
            </div>
            <div class="metric-title">运动量</div>
          </div>
          <div class="metric-chart">
            <div class="chart-line" data-max="100">
              <div class="value-point" :style="{ left: getValuePosition(exerciseVolume, 100) + '%' }">
                {{ exerciseVolume }}
              </div>
            </div>
            <div class="reference-lines">
              <div class="line">
                <span class="line-label">同龄学员中位值</span>
                <span class="line-value">{{ referenceValues.exerciseVolume }}</span>
              </div>
              <!-- <div class="line">
                <span class="line-label">职业学员中位值</span>
                <span class="line-value">24</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 单项数据解释 -->
      <div class="data-interpretation">
        <h3>单项数据解释</h3>
        <div class="interpretation-content">
          <p><strong>速度：</strong>一次训练课中一个阶段内有效跑速度最大值即为最大速度，该值越大表明爆发力越好。</p>
          <p><strong>方向的改变：</strong>记录运动员在场上变向的次数，变化次数多说明该名运动员在场上移动灵活。</p>
          <p><strong>跳跃：</strong>与训练课比赛时特点相关的各种跳跃次数，数字越大说明对下肢的负荷越大。</p>
          <p><strong>加速负荷：</strong>每个加速过程中的最大负荷值，该值越大说明爆发力越好。</p>
          <p><strong>力学强度：</strong>使用加速度计算得到的瞬时值，静止时为零，运动时越大说明运动强度越大。</p>
          <p><strong>累积加速负荷：</strong>在一次训练课中，由加速产生的所有瞬时值累加得到，反映了整体运动负荷。</p>
        </div>
      </div>

      <!-- VEAI计算公式 -->
      <div class="veai-formula">
        <h3>VEAI计算公式</h3>
        <div class="formula-content">
          <div class="formula-items">
            <div class="formula-item">
              <span class="formula-text">速度 + 方向改变 = 敏捷</span>
            </div>
            <div class="formula-item">
              <span class="formula-text">跳跃次数 × 累积加速负荷 + 运动量 = 耐力</span>
            </div>
            <div class="formula-item">
              <span class="formula-text">加速负荷最大值 × 力学强度 = 力量</span>
            </div>
          </div>
          <div class="scores">
            <div class="score-item">
              <div class="label">敏捷</div>
              <div class="value">{{ abilityScores.agility }}/15</div>
            </div>
            <div class="score-item">
              <div class="label">耐力</div>
              <div class="value">{{ abilityScores.endurance }}/15</div>
            </div>
            <div class="score-item">
              <div class="label">力量</div>
              <div class="value">{{ abilityScores.strength }}/15</div>
            </div>
          </div>
        </div>
      </div>

      <!-- VEAI技术介绍 -->
      <!-- <div class="veai-introduction">
        <h3>VEAI技术特点</h3>
        <div class="tech-features">
          <div class="feature">
            <i class="el-icon-cpu"></i>
            <h4>完全自动化</h4>
            <p>采用先进的AI算法，实现数据的自动采集、处理和分析，无需人工干预。</p>
          </div>
          <div class="feature">
            <i class="el-icon-aim"></i>
            <h4>高精度定位</h4>
            <p>精确到厘米级的位置和运动数据采集，为运动表现分析提供可靠数据支持。</p>
          </div>
          <div class="feature">
            <i class="el-icon-timer"></i>
            <h4>零延迟响应</h4>
            <p>近乎零延迟的实时数据传输和处理，确保教练和运动员获得即时反馈。</p>
          </div>
          <div class="feature">
            <i class="el-icon-connection"></i>
            <h4>系统集成</h4>
            <p>与第三方系统无缝集成，支持数据导出和共享，扩展应用场景。</p>
          </div>
          <div class="feature">
            <i class="el-icon-mobile"></i>
            <h4>便携设计</h4>
            <p>采用小型轻便的芯片传感器，佩戴舒适，不影响运动表现。</p>
          </div>
          <div class="feature">
            <i class="el-icon-data-analysis"></i>
            <h4>数据洞察</h4>
            <p>为运动员、教练和观众提供深度的数据分析和即时洞察。</p>
          </div>
        </div>
      </div> -->
    </div>
    <HomeFooter :activeKey="activeKey"></HomeFooter>
  </div>
</template>

<script>
import HomeFooter from "@/components/homeFooter.vue";
import HomeTop from "@/components/homeTop.vue";
import { getResultDetail } from '@/request/api';

export default {
  name: "AnalysisReport",
  components: {
    HomeFooter,
    HomeTop
  },
  data() {
    return {
      activeKey: 2,
      topTitle: "运动数据分析",
      resultId: null,
      examData: {
        title: "",
        level: "",
      },
      studentInfo: {
        name: "",
        testTime: "",
      },
      abilityScores: {
        strength: 0,
        agility: 0,
        endurance: 0,
      },
      testDuration: "00:00:00",
      testDistance: 0,
      distancePerMinute: 0,
      speed: 0,
      accelerationLoad: 0,
      directionChanges: 0,
      mechanicalIntensity: 0,
      jumps: 0,
      accumulatedLoad: 0,
      exerciseVolume: 0,
      referenceValues: {
        speed: 0,
        accelerationLoad: 0,
        directionChanges: 0,
        mechanicalIntensity: 0,
        jumps: 0,
        accumulatedLoad: 0,
        exerciseVolume: 0,
      },
    };
  },
  methods: {
    getValuePosition(value, max) {
      return (value / max) * 100;
    },
    formatDuration(startTime, endTime) {
      if (!startTime || !endTime) return '00:00:00';
      const start = new Date(`2000-01-01 ${startTime}`);
      const end = new Date(`2000-01-01 ${endTime}`);
      const diff = end - start;
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    async fetchResultDetail() {
      try {
        const response = await getResultDetail(this.resultId);
        if (response.code === 200) {
          const data = response.data;
          
          // 更新考试信息
          this.examData = {
            title: data.exam.title || '',
            level: data.exam.level || '',
          };
          
          // 更新考生信息
          this.studentInfo = {
            name: data.student.name || '',
            testTime: data.student.testTime || '',
          };
          
          // 更新运动能力成绩
          const abilityData = data.ability_scores || {};
          this.abilityScores = {
            strength: parseFloat(abilityData.strength || 0),
            agility: parseFloat(abilityData.agility || 0),
            endurance: parseFloat(abilityData.endurance || 0),
          };

          // 更新运动数据
          const deductions = data.ability_scores?.deductions || {};
        //   const avgValues = data.ability_scores || {};
          
          this.speed = deductions.speed_max || 0;
          this.accelerationLoad = deductions.max_acc_load || 0;
          this.directionChanges = deductions.orientation_changes || 0;
          this.mechanicalIntensity = deductions.mechanical_intensity || 0;
          this.jumps = deductions.jumps || 0;
          this.accumulatedLoad = deductions.acc_load || 0;
          this.exerciseVolume = deductions.exertions || 0;

          // 更新中位值参考数据
          this.referenceValues = {
            speed: deductions.avg_speed_max || 0,
            accelerationLoad: deductions.avg_max_acc_load || 0,
            directionChanges: deductions.avg_orientation_changes || 0,
            mechanicalIntensity: deductions.avg_mechanical_intensity || 0,
            jumps: deductions.avg_jumps || 0,
            accumulatedLoad: deductions.avg_acc_load || 0,
            exerciseVolume: deductions.avg_exertions || 0,
          };
          
        } else {
          this.$message.error(response.message || '获取成绩详情失败');
        }
      } catch (error) {
        console.error('获取成绩详情失败:', error);
        this.$message.error(error.message || '获取成绩详情失败，请稍后重试');
      }
    }
  },
  created() {
    this.resultId = this.$route.query.id;
    if (!this.resultId) {
      this.$message.error('未找到成绩信息');
      this.$router.push('/userResult');
      return;
    }
    this.fetchResultDetail();
  }
};
</script>

<style src="../../assets/css/user/analysisReport.css" scoped></style> 